import { render, staticRenderFns } from "./ScoreCardFullScreen.vue?vue&type=template&id=0ae2e09c&"
import script from "./ScoreCardFullScreen.vue?vue&type=script&lang=js&"
export * from "./ScoreCardFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardFullScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports